// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__Jg7qi","container":"Slider_container__CtDkZ","icons":"Slider_icons__JOy7K","icon":"Slider_icon__jw+Mv"};